import React from 'react';
import { FaFacebookF, FaInstagram,FaEnvelope} from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Footer(props){

    return(
    <>

        <div  className="h-auto bg-gray-100 z-10 flex flex-col items-center w-full" >
            {
                props.mensaje ?
                <div className="w-full bg-fondo p-8 md:p-12 flex flex-col md:flex-row items-center justify-around text-center md:text-left">
                    <div className="w-full md:w-1/2 p-3">
                        <h1 className="text-primary text-sm font-bold uppercase tracking-widest">Para cualquier duda o consulta</h1>
                        <p className="font-extrabold text-2xl md:text-3xl text-white mt-2">Confía tu futuro a nuestro equipo de profesionales</p>
                    </div>
                    <div >
                        <Link to="/contact" className="bg-primary text-white font-semibold mx-auto my-2 py-3 px-6 rounded-full inline-block hover:bg-white hover:text-fondo">Contáctanos</Link>
                    </div>
                </div>:null
            }
          <div className="p-8 md:p-10 z-10 flex flex-col md:flex-row items-start w-full landing-wrap"> 
            <div className="w-full m-3 flex-col text-start hidden md:flex">
                <h1 className="mb-4 text-xl font-semibold text-fondo">Empresa</h1>
                <ul className="text-gray-600">
                    <li className="mb-2">
                    <Link to="/terminos" className='hover:text-primary'>Términos y condiciones</Link>
                    </li>
                    <li className="mb-2">
                        <Link to="/politicas" className='hover:text-primary'>Políticas de privacidad</Link>
                    </li>
                    <li className="mb-2">
                    <a href='https://wa.me/59175413873' target='_blank' rel="noopener noreferrer" className='hover:text-primary'>
                       Soporte
                      </a>
                    </li>
                    <li className="mb-2">
                    <Link to="/contact"  className='hover:text-primary'>Contacto</Link>
                    </li>
                </ul>
            </div>
            <div className="w-full m-3 flex-col text-start hidden md:flex"> 
                <h1  className="mb-4 text-xl font-semibold text-fondo">Enlaces rápidos</h1>
                <ul className="text-gray-600">
                    <li className="mb-2">
                        <Link to="/" className='hover:text-primary'>Inicio</Link>
                    </li>
                    <li className="mb-2">
                        <Link to="/team" className='hover:text-primary'>Nosotros</Link>
                    </li>
                    <li className="mb-2">
                        <Link to="/pricing" className='hover:text-primary'>Planes</Link>
                    </li>
                    <li className="mb-2">
                        <Link to="/service" className='hover:text-primary'>Servicio</Link>
                    </li>
                    <li className="mb-2">
                        <Link to="/contact" className='hover:text-primary'>Contactos</Link>
                    </li>
                </ul>
            </div>
            {
                props.contact ?
               null
              :<div className="w-full m-3 p-1 text-center md:text-left">
              <h1 className="mb-4 text-xl font-semibold text-fondo">Suscríbete con nosotros</h1>
              <p className="text-gray-600">Recibe las últimas convocatorias y recursos</p>
              <div className='flex flex-col md:block'>
              <input 
              id='footer-message'
              type="text" 
              placeholder="Suscríbete ahora..." 
              className="bg-white border border-primary rounded-lg p-2 mt-5 w-full md:w-auto"/>
              <button 
              className="bg-primary text-white font-bold my-2 py-2 px-4 rounded-lg mt-3 hover:bg-fondo"
              onClick={()=>{
                const message = document.getElementById('footer-message').value;
                if(message.length>0){
                  window.open(`https://api.whatsapp.com/send?phone=59157953389&text=${message}`);
                }else{
                  alert('Escríbenos tu mensaje');
                }
              }}
              >Suscríbete</button>
              </div>  
            </div> 
            }
            
            <div className="w-full m-3 text-center md:text-left">
                <h1 className="mb-4 text-3xl font-bold"><span className="text-primary">A</span>priori</h1>
                <a className="font-semibold text-fondo hover:text-primary" href="mailto:apriori.bolivian@gmail.com" >apriori.bolivian@gmail.com</a>
                <p className="mt-1"><a href='https://wa.me/59157953389' target='_blank' rel="noopener noreferrer" className='hover:text-primary'>
                +591 57953389
                      </a></p>
            </div>

            
          </div>
          <div className="flex flex-col md:flex-row justify-around items-center w-full bg-gray-200 py-4 px-6 text-center">
              <div className="text-gray-600 text-sm">© Copyright Reserved to AprioriBolivia by R&L Dev</div>
              
              <div className="flex flex-row justify-center mt-3 md:mt-0">
                  <a href="https://www.facebook.com/aprioribol" target="_blank" rel="noopener noreferrer" className="flex flex-row items-center mx-3 hover:text-primary">
                      <FaFacebookF  className="text-xl"/>
                      <p className='hidden md:block ml-2'>Facebook</p>
                  </a>
                  <a href="https://www.instagram.com/apriori_bo" target="_blank" rel="noopener noreferrer" className="flex flex-row items-center mx-3 hover:text-primary">
                      <FaInstagram className="text-xl"/>
                      <p className='hidden md:block ml-2'>Instagram</p>
                  </a>
                  <a href="mailto:apriori.bolivian@gmail.com" className="flex flex-row items-center mx-3 hover:text-primary">
                      <FaEnvelope  className="text-xl"/>
                      <p className='hidden md:block ml-2'>Correo</p>
                  </a>

              </div>
          </div>
        </div>
    </>
    );
};
